import React from "react";
import { FormattedMessage } from "react-intl";

import { ROUTES } from "@utils/constant";

export const BREADCRUMB_ITEMS = [
  {
    label: <FormattedMessage id="title_coupons" />,
    url: ROUTES.ADMIN_COUPONS_LIST.URL,
  },
  {
    label: <FormattedMessage id="title_create_coupon" />,
  },
];
